import { render } from "./InputPrice.vue?vue&type=template&id=70967e2c&ts=true"
import script from "./InputPrice.vue?vue&type=script&lang=ts"
export * from "./InputPrice.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__